import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const ibc16_6_3_or_4HardRule = {
    id: StowageRuleId.Ibc16_6_3_or_4HardRule,
    name: 'IBC 16.6.3/4 Cargoes not to be exposed to excessive heat cannot be stowed in any deck tank.',
    lastUpdatedUtc: '2014-10-07T13:24:00',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                operator: BooleanOperator.OR,
                children: [
                    {
                        leaf: {
                            properties: [
                                {
                                    name: 'Product category specific and operational requirements',
                                    fieldPath: 'cargo.product.category.ibcSpecificRequirements',
                                    type: 'array',
                                    location: StowageRulePropertyLocation.Tank,
                                },
                                {
                                    name: 'IBC chapter 16.6.3',
                                    type: 'string',
                                    referenceValue: 'IBC-16.6.3',
                                    location: StowageRulePropertyLocation.NA,
                                },
                            ],
                            scope: StowageRuleTestScope.Tank,
                            operator: StowageRulePropertyOperator.Contains,
                        },
                    },
                    {
                        leaf: {
                            properties: [
                                {
                                    name: 'Product category specific and operational requirements',
                                    fieldPath: 'cargo.product.category.ibcSpecificRequirements',
                                    type: 'array',
                                    location: StowageRulePropertyLocation.Tank,
                                },
                                {
                                    name: 'IBC chapter 16.6.4',
                                    type: 'string',
                                    referenceValue: 'IBC-16.6.4',
                                    location: StowageRulePropertyLocation.NA,
                                },
                            ],
                            scope: StowageRuleTestScope.Tank,
                            operator: StowageRulePropertyOperator.Contains,
                        },
                    },
                ],
            },
            {
                leaf: {
                    properties: [
                        {
                            name: 'Is deck tank',
                            fieldPath: 'isDeckTank',
                            type: 'boolean',
                            location: StowageRulePropertyLocation.Tank,
                        },
                        {
                            name: 'Reference value',
                            type: 'boolean',
                            referenceValue: 'true',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.Equals,
                },
            },
            {
                leaf: {
                    properties: [
                        {
                            name: 'Tank content weight',
                            fieldPath: 'getStowedWeight',
                            type: 'number',
                            location: StowageRulePropertyLocation.Tank,
                        },
                        {
                            name: 'Reference value',
                            type: 'number',
                            referenceValue: '0',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.IsGreaterThan,
                },
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.HardRule,
        parameter: 'According to IBC 16.6.3/4, this product cannot be carried in deck tanks.',
    },
} as StowageRuleBM;
